import React from 'react';

const icons = {
  home: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  status: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  webhook: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>,
  login: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>,
  fare: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>,
  driver: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  create: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>,
  edit: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  list: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  cancel: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>,
  branch: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 21h18M6 21V7l6-4 6 4v14M10 21v-6h4v6"/></svg>,
  wallet: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="6" width="20" height="14" rx="2"/><path d="M2 10h20M16 14h2"/></svg>,
};

const apiIconMap = {
  login: icons.login,
  'estimated-fare': icons.fare,
  'nearest-driver': icons.driver,
  'create-order': icons.create,
  'booking-list': icons.list,
  'list-order': icons.list,
  'edit-order': icons.edit,
  'cancel-order': icons.cancel,
  branches: icons.branch,
  'create-branch': icons.branch,
  balance: icons.wallet,
};

function NavItem({ active, onClick, icon, label, showBadge }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        width: '100%', textAlign: 'left', border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center', gap: 9,
        padding: '7px 10px',
        borderRadius: 8, marginBottom: 1,
        background: active ? 'var(--accent-bg)' : 'transparent',
        color: active ? 'var(--accent)' : 'var(--text-secondary)',
        fontFamily: 'Inter, sans-serif', fontSize: 13,
        fontWeight: active ? 600 : 400,
        position: 'relative',
        outline: 'none',
      }}
      onMouseEnter={e => {
        if (!active) {
          e.currentTarget.style.background = 'var(--bg-elevated)';
          e.currentTarget.style.color = 'var(--text-primary)';
        }
      }}
      onMouseLeave={e => {
        if (!active) {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = 'var(--text-secondary)';
        }
      }}
    >
      {active && (
        <div style={{
          position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)',
          width: 3, height: 18, borderRadius: '0 3px 3px 0',
          background: 'var(--accent)',
        }} />
      )}
      <span style={{ opacity: active ? 1 : 0.65, flexShrink: 0, display: 'flex' }}>{icon}</span>
      <span style={{ flex: 1, lineHeight: 1.3 }}>{label}</span>
      {showBadge && (
        <span style={{
          fontSize: 9, fontWeight: 700, padding: '2px 6px', borderRadius: 5,
          background: 'var(--post-bg)', color: 'var(--post)',
          border: '1px solid var(--post-border)',
          fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.04em',
          lineHeight: 1.4,
        }}>POST</span>
      )}
    </button>
  );
}

function SectionLabel({ children }) {
  return (
    <div style={{
      fontSize: 10, fontWeight: 700, color: 'var(--text-muted)',
      textTransform: 'uppercase', letterSpacing: '0.08em',
      padding: '16px 10px 6px',
    }}>{children}</div>
  );
}

export default function Sidebar({ apis = [], activePage, setActivePage, open }) {
  return (
    <aside className={`app-sidebar${open ? ' is-open' : ''}`} aria-hidden={!open}>
      <SectionLabel>Overview</SectionLabel>
      <NavItem
        active={activePage === 'home'}
        onClick={() => setActivePage('home')}
        icon={icons.home}
        label="Getting Started"
      />
      <NavItem
        active={activePage === 'status-codes'}
        onClick={() => setActivePage('status-codes')}
        icon={icons.status}
        label="Status Codes"
      />
      <NavItem
        active={activePage === 'webhook'}
        onClick={() => setActivePage('webhook')}
        icon={icons.webhook}
        label="Webhook Reference"
      />

      <div style={{ height: 1, background: 'var(--border)', margin: '10px 0' }} />

      <SectionLabel>Endpoints</SectionLabel>
      {apis.map(api => (
        <NavItem
          key={api.id}
          active={activePage === api.id}
          onClick={() => setActivePage(api.id)}
          icon={apiIconMap[api.id]}
          label={api.name}
          showBadge
        />
      ))}

      <div style={{ height: 1, background: 'var(--border)', margin: '10px 0' }} />

      <div style={{
        margin: '4px 0',
        background: 'linear-gradient(135deg, var(--accent-bg), rgba(139,92,246,0.06))',
        border: '1px solid var(--accent-glow)',
        borderRadius: 10, padding: '12px 14px',
      }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 4 }}>
          Need Help?
        </div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.5, marginBottom: 8 }}>
          Contact us for integration support.
        </div>
        <a href="mailto:support@wiyak.com" style={{
          display: 'inline-flex', alignItems: 'center', gap: 5,
          fontSize: 12, color: 'var(--accent)', fontWeight: 500,
          textDecoration: 'none',
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          support@wiyak.com
        </a>
      </div>
    </aside>
  );
}
